<script lang="ts" setup>
import { Prop } from 'vue'

import BottomPromocode from '@/components/Sales/Sale/BottomPromocode.vue'

import { Code } from '~/api/modules/sales/types'

const emit = defineEmits(['copyCode'])

const props = defineProps({
  isVisiblePromocode: {
    type: Boolean,
    required: true,
  },
  isActiveCode: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  code: {
    type: Object,
    required: false,
    default: () => null,
  } as Prop<Code | null>,
  shortDescription: {
    type: String,
    required: true,
  },
})

const copyCode = () => emit('copyCode', props.code?.promocode)
</script>

<template>
  <div class="sale__bottom">
    <div class="sale__bottom-description" v-html="shortDescription" />

    <div v-if="isVisiblePromocode && code" class="sale__bottom-promocode">
      <bottom-promocode :code="code" @copy-promocode="copyCode" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sale__bottom {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-description {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;

    :deep(p) {
      margin: 0;
    }
  }

  &-promocode {
    margin-top: 25px;
  }
}
</style>
